import { render, staticRenderFns } from "./SearchCompanies.vue?vue&type=template&id=f948bd6e&scoped=true"
import script from "./SearchCompanies.vue?vue&type=script&lang=js"
export * from "./SearchCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f948bd6e",
  null
  
)

export default component.exports